export const isNil = (value) => {
    switch (value) {
        case null:
        case undefined:
        case "":
            return true;
        default:
            false;
    }
};
//# sourceMappingURL=isNil.js.map